import { render, staticRenderFns } from "./CreateAdvertisement.vue?vue&type=template&id=ae98fa06&scoped=true&"
import script from "./CreateAdvertisement.vue?vue&type=script&lang=js&"
export * from "./CreateAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./CreateAdvertisement.vue?vue&type=style&index=0&id=ae98fa06&prod&scoped=true&lang=css&"
import style1 from "./CreateAdvertisement.vue?vue&type=style&index=1&id=ae98fa06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae98fa06",
  null
  
)

export default component.exports